export const disableDarkMode = () => {
  document.documentElement.classList.remove('dark');
};
